<template>

  <div class="vz-search">
    <div class="vz-search-panel" :class="{ 'vz-open': open, 'vz-loading': loading }" @click.stop="closeSearch">
      <div class="vz-search-panel-content" @click.stop>
        <form class="vz-search-form" :class="{ 'vz-focus': focused }" @submit.prevent="search">
          <input class="vz-search-input" type="search" v-model="value" :placeholder="placeholder" @focus="setFocus(true)" @blur="setFocus(false)"/>
          <i class="ic-loader vz-spin vz-search-form-loading-ic"></i>
          <i class="ic-search vz-ic-input vz-search-form-ic" @click="search"></i>
        </form>
        <i class="ic-x vz-close-panel" @click="closeSearch"></i>
      </div>
    </div>
    <i class="ic-search vz-ic-trigger" @click="toggleSearch"></i>
  </div>

</template>

<script>
import VzBase from '../vz-base.vue';

export default {

  name: 'VzSearchField',
  extends: VzBase,
  emits: ['open', 'close', 'search'],

  props: {
    placeholder: {
      type: String,
      default: 'Buscar...'
    },
    loading: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    open: false,
    value: '',
    focused: false
  }),

  methods: {

    openSearch: function () {
      this.open = true;
      this.$emit('open');
    },

    closeSearch: function () {
      this.open = false;
      this.$emit('close');
    },

    toggleSearch: function () {
      if(this.open) {
        this.closeSearch();
      } else {
        this.openSearch();
      }
    },

    search: function () {
      if(this.value) {
        this.closeSearch();
        this.$emit('search', this.value);
      }
    },

    setFocus: function (value) {
      this.focused = value;
    }

  }

}
</script>

<style>

.vz-search-panel {
  position: fixed;
  top: 0;
  left: 0;
  width: 0;
  height: 0;
  overflow: hidden;
  background-color: rgba(0,0,0,0.6);
  opacity: 0;
  transition-property: opacity, width, height;
  transition-duration: 0.3s, 0s, 0s;
  transition-delay: 0s, 0.6s, 0.6s;
}

.vz-search-panel.vz-open {
  width: 100%;
  height: 100%;
  opacity: 1;
  transition-delay: 0s, 0s, 0s;
}

.vz-search-panel-content {
  position: absolute;
  top: 0;
  left: 50%;
  width: 100%;
  max-width: 580px;
  background-color: #0c0c0c;
  padding: 54px 32px 32px;
  border-radius: 0 0 16px 16px;
  box-shadow: 1px 0 8px rgba(0, 0, 0, 0.57);
  transition: transform 0.3s;
  transform: translate(-50%, -110%);
}

.vz-open .vz-search-panel-content {
  transform: translate(-50%, 0);
}

.vz-search-form {
  position: relative;
  border-width: 1px;
  border-style: solid;
  border-color: #707070;
  border-radius: 2em;
  background-color: rgba(13, 9, 9, 0.61);
  margin: 0 auto;
  padding: 0 42px 0 0;
  width: 100%;
  max-width: 400px;
  transition-property: width, max-width, border-color;
  transition-duration: 0.3s;
}

.vz-search-form:hover {
  border-color: var(--primary-color-over);
}

.vz-search-form:active,
.vz-search-form:focus,
.vz-search-form.vz-focus
{
  border-color: var(--primary-color-active);
}

.vz-search-input {
  background-color: transparent;
  font-family: inherit;
  font-size: 0.85em;
  line-height: 34px;
  border-width: 0;
  padding: 0 0 0 16px;
  outline: none;
  width: 100%;
  color: #ffffff;
  -webkit-appearance: none;
}

.vz-search-input::-webkit-search-cancel-button {
  opacity: 0;
}

.vz-search-input::placeholder {
  color: rgba(255,255,255,0.4);
}

.vz-search-input:focus {
  outline: none;
}

.vz-ic-input,
.vz-search-form-loading-ic
{
  display: inline-block;
  font-size: 16px;
  position: absolute;
  right: 16px;
  color: #8D8C8C;
  transform: translate(0, -50%);
  transition: opacity 0.3s;
}

.vz-ic-input {
  top: 50%;
  cursor: pointer;
}

.vz-ic-input:hover {
  color: var(--primary-color-over);
}

.vz-ic-input:active {
  color: var(--primary-color-active);
}

.vz-loading .vz-ic-input,
.vz-search-form-loading-ic
{
  opacity: 0;
}

.vz-search-form-loading-ic {
  top: 9px;
}

.vz-loading .vz-search-form-loading-ic {
  opacity: 1;
}

.vz-close-panel {
  position: absolute;
  top: 16px;
  right: 16px;
  cursor: pointer;
  font-size: 16px;
  color: #ffffff;
}

.vz-close-panel:hover,
.vz-ic-trigger:hover
{
  color: var(--primary-color-over);
}

.vz-close-panel:active,
.vz-ic-trigger:active
{
  color: var(--primary-color-active);
}

.vz-ic-trigger {
  font-size: 24px;
  cursor: pointer;
  color: #ffffff;
}

@media (min-width: 1024px) {

  .vz-search-panel {
    background-color: transparent;
    position: relative;
    top: auto;
    left: auto;
    width: 100%;
    height: auto;
    opacity: 1;
  }

  .vz-search-panel-content {
    position: relative;
    top: auto;
    left: auto;
    margin: 0;
    padding: 0;
    width: 100%;
    max-width: none;
    box-shadow: none;
    background-color: transparent;
    transform: none;
    display: flex;
    justify-content: flex-end;
  }

  .vz-open .vz-search-panel-content {
    transform: none;
  }

  .vz-search-form {
    width: 207px;
    max-width: none;
    margin: 0;
  }

  .vz-search-form.vz-focus {
    width: 100%;
  }

  .vz-ic-trigger,
  .vz-close-panel
  {
    display: none;
  }

}

</style>